import * as React from "react";

import {
  Container,
  Grid,
  GridJustification,
  GridSize,
  GridSpacing,
  makeStyles,
  Theme,
  useMediaQuery,
} from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    "& > *": {
      width: "100%",
    },
  },
  stickyContainer: {
    position: "sticky",
    height: "100vh",
    top: 0,
  },
}));

interface IProps {
  showLeftColumnOnMobile?: boolean;
  header: React.ReactElement;
  justify?: GridJustification;
  leftColumn: React.ReactElement;
  rightColumn: React.ReactElement;
  columnSpacing?: GridSpacing;
  leftColumnGridLayout?: GridSize;
  rightColumnGridLayout?: GridSize;
  makeLeftColumnSticky?: boolean;
}

export const TwoColumnLayout: React.FC<IProps> = ({
  showLeftColumnOnMobile = false,
  header,
  justify = "flex-start",
  leftColumn,
  rightColumn,
  columnSpacing = 5,
  leftColumnGridLayout = 5,
  rightColumnGridLayout = 6,
  makeLeftColumnSticky = false,
}) => {
  const classes = useStyles();
  const isMobileWidth = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  const showLeftColumn = isMobileWidth ? showLeftColumnOnMobile : true;
  return (
    <Container fixed>
      <Grid
        container
        className={classes.root}
        justifyContent={justify}
        spacing={columnSpacing}
      >
        <Grid item xs={12}>
          {header}
        </Grid>
        {showLeftColumn && (
          <Grid
            item
            sm={12}
            md={leftColumnGridLayout}
            className={clsx(makeLeftColumnSticky && classes.stickyContainer)}
          >
            {leftColumn}
          </Grid>
        )}
        <Grid item xs={12} md={rightColumnGridLayout}>
          {rightColumn}
        </Grid>
      </Grid>
    </Container>
  );
};
